import ActivityChart from './ActivityChart'
import BehaviourChart from './BehaviourChart'
import BloodGlucoseChart from './BloodGlucoseChart'
import BloodOxygenChart from './BloodOxygenChart'
import BloodPressureChart from './BloodPressureChart'
import DailyChart from './DailyChart'
import DailyTotalChart from './DailyTotalChart'
import FluidsChart from './FluidsChart.tsx'
import FoodChart from './FoodChart'
import HealthVisitChart from './HealthVisitChart'
import HeartRateChart from './HeartRateChart'
import IncidentsChart from './IncidentsChart'
import LineChart from './LineChart'
import MobilityChart from './MobilityChart'
import MoodChart from './MoodChart'
import MustScoreChart from './MustScoreChart'
import PainChekChart from './PainChekChart'
import RespiratoryRateChart from './RespiratoryRateChart'
import SeizureChart from './SeizureChart'
import StoolChart from './StoolChart'
import TemperatureChart from './TemperatureChart'
import TurnsChart from './TurnsChart'
import WashChart from './WashChart'
import WaterlowChart from './WaterlowChart'
import WeightChart from './WeightChart'

export const charts = {
  ActivityChart,
  BehaviourChart,
  BloodOxygenChart,
  BloodPressureChart,
  BloodGlucoseChart,
  DailyChart,
  DailyTotalChart,
  FluidsChart,
  FoodChart,
  HealthVisitChart,
  HeartRateChart,
  IncidentsChart,
  LineChart,
  MoodChart,
  MobilityChart,
  MustScoreChart,
  RespiratoryRateChart,
  StoolChart,
  TemperatureChart,
  TurnsChart,
  WaterlowChart,
  WeightChart,
  WashChart,
  PainChekChart,
  SeizureChart
}

export default charts
